import React from "react";

export const SchedulerSvg = ({ pathNames }) => {
  const stroke = pathNames?.includes("/home/scheduler") ? "#ffffff" : "#667085";
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3.333" y="4.167" width="13.333" height="13.333" rx="2" />
          <path d="M13.333 2.5v3.333M6.667 2.5v3.333M3.333 8.333h13.333" />
        </g>
      </svg>
    </div>
  );
};

export default SchedulerSvg;
